import React, { useEffect, useState } from 'react';
import './HomeNav.scss';
import Label from './Label';
import { _setHome, _setCurrentScene } from '../../store/actionCreators';
import data from '../../locales/en.json';
import { useSelector, useDispatch } from 'react-redux';
import { CSSTransition } from 'react-transition-group';
import { ScaleText } from '../../utils';

const HomeNav = () => {
  const [show, setShow] = useState(false);
  const home = useSelector((state) => state.home);
  const transitioning = useSelector((state) => state.transitioning);
  const homeNavIn = useSelector((state) => state.homeNavIn);

  const dispatch = useDispatch();

  // eslint-disable-next-line
  const scaledText = ScaleText(
    data.Content.scene.map((d, i) => `Content.scene.${i}.title`),
    { xlg: 18, lg: 14 },
    '1.3em',
  );

  useEffect(() => {
    if (home && homeNavIn) setShow(true);
    else setShow(false);
    // eslint-disable-next-line
  }, [homeNavIn]);

  const setHome = (bool) => {
    dispatch(_setHome(bool));
  };
  const setCurrentScene = (num) => {
    dispatch(_setCurrentScene(num));
  };

  const handleClickScene = (i) => {
    if (!transitioning) {
      setHome(false);
      setCurrentScene(i);
    }
  };

  return (
    <CSSTransition
      in={show}
      timeout={{ enter: 400 + 205 * 5, exit: 110 }}
      classNames="homenav-display"
      unmountOnExit>
      <div className="homenav white">
        {data.Content.scene.map(({ title }, i) => (
          <div
            className="labels slow-01-staggered"
            style={{ transitionDelay: `${i * 205}ms` }}
            key={i}>
            <Label
              text={title}
              handleClickScene={handleClickScene}
              i={i}
              scaledText={scaledText}
            />
          </div>
        ))}
      </div>
    </CSSTransition>
  );
};

export default HomeNav;
